import React from "react";
import { Route, Redirect } from "react-router-dom";
import { clearAccessToken, hasAccessToken } from "./constants/auth";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (hasAccessToken()) {
        return <Component {...props} />;
      } else {
        clearAccessToken();
        return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
      }
    }}
  />
);
